import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';
import { LOCALIZED_SHARED_ROUTES, LocalizedRouteService, ProfileState, SHARED_ROUTE_IDS } from '@lexplus-shared-lib';

@Service()
export class RedirectToDashboardIfIsLoggedInService {
  private readonly store = inject(Store);
  private readonly router = inject(Router);
  private readonly localizedRouteService = inject(LocalizedRouteService);

  public canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.store.selectSnapshot(ProfileState.isLoggedIn)) {
      void this.router.navigateByUrl(
        '/' + this.localizedRouteService.getLocalizedRoute(LOCALIZED_SHARED_ROUTES[SHARED_ROUTE_IDS.DASHBOARD]),
      );
      return false;
    } else {
      return true;
    }
  }
}

export const RedirectToDashboardIfIsLoggedInGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return <boolean>inject(RedirectToDashboardIfIsLoggedInService).canActivate(next, state);
};
